export default __webpack_public_path__ + "6ebc84e770e0023b757755f830115a3d.png";